import { downloadFile } from 'shared/libs/download/downloadFile'
import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'
import { useHandleRequest } from 'shared/libs/hooks/useHandleRequest/useHandleRequest'
import { cleanObject } from 'shared/libs/obj/cleanObjFromNull'
import { ParamKey } from 'shared/types/QueryModel'

import { useState } from 'react'

import { downloadTableApi } from '../../services/downloadTableApi'

interface Params {
  params: ParamKey[]
}

export const useDownloadTable = ({ params }: Params) => {
  const { getParam } = useAppSearchParams()
  const { handleError } = useHandleRequest()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleDownloadTable = async (url: string) => {
    try {
      setIsLoading(true)
      const filteredParams = Object.fromEntries(
        params.map((param) => [param, getParam(param)]),
      )
      const { filename, csvFile } = await downloadTableApi.downloadTable({
        ...cleanObject(filteredParams),
        url,
      })
      downloadFile({ file: csvFile, filename })
    } catch (err) {
      handleError(err)
    } finally {
      setIsLoading(false)
    }
  }

  return { handleDownloadTable, isLoading }
}
